/* eslint-disable prettier/prettier */
import React from "react";
import { connect } from 'react-redux';
import compose from 'recompose/compose';
import { Link } from "react-router-dom";
import firebase, { db, sendEmail, storage } from "firebase/fbConfig.js"
import axios from 'axios'

// react component for creating dynamic tables
import ReactTable from "react-table";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Slide from "@material-ui/core/Slide";
import Switch from "@material-ui/core/Switch";
import Collapse from '@material-ui/core/Collapse';
import List from '@material-ui/core/List';
import ListItem from "@material-ui/core/ListItem";

// @material-ui/icons
import Assignment from "@material-ui/icons/Assignment";
import Dvr from "@material-ui/icons/Dvr";
import Favorite from "@material-ui/icons/Favorite";
import Check from '@material-ui/icons/Check';
import Close from "@material-ui/icons/Close";
import ArrowUpward from "@material-ui/icons/ArrowUpward";
import ArrowDownward from "@material-ui/icons/ArrowDownward";

// core components
import Chat from "components/Chat/ChatDash.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardIcon from "components/Card/CardIcon.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import Table from "components/Table/Table.jsx";
import TaskViewer from "components/Tasks/TaskViewer.jsx";


import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";
import Style from "assets/jss/material-dashboard-pro-react/views/actionsStyle";


// Forms
import ActionSubmitForm from "components/Forms/ActionSubmitForm.jsx"
import ShipFullScreenMap from "../Maps/ShipFullScreenMap";
import AllTrucks from "../../views/Maps/AllTrucks";

// Firebase Redux Integration
import { tableToFirestoreObjects, updateFirestoreWithTableData, addFieldToDocument } from "store/actions/firestoreActions"
import { startSetActionsList, startToggleCompleted, setUserScore, setFirstAction } from "store/actions/actionsActions"
import FlightSearchForm from "../../components/Forms/FlightSearchFormNew";
import RequestSignature from "../../components/Forms/RequestSignature";
import FavoritedOrders from "../Dispatch/FavoritedOrders"
import FavOrderParent from "../Dispatch/FavOrderParent";
import NotificationsDash from "../Customer/NotificationsDash"
import MarketAreaConverter from "./MarketAreaConverter"

const Transition = (props) => {
  return <Slide direction="down" {...props} />
}

class Orders extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      noGroupsShippers: {},
      dataLoaded: false,
      updateActionModal: false,
      editActionID: "",
      editActionTitle: "",
      coordinates: {
        destination: { lat: 25.7616798, lng: -80.1917902 },
        driver: { lat: 39.7975670266926, lng: -104.90824287998849 },
        origin: { lat: 39.7392358, lng: -104.990251 }
      },

      checkedShippers: true,
      checkedOrders: true,

    };
  }
  handleSwitchShipper = (state) => {
    console.log("Orange", state)
    this.setState({ checkedShippers: state });
  };
  handleSwitchOrders = (state) => {
    this.setState({ checkedOrders: state })
  }
  handleClickOpen = (modal, actionID, actionTitle) => {
    var x = [];
    x[modal] = true;
    this.setState({
      ...x,
      editActionID: actionID,
      editActionTitle: actionTitle
    });
  }

  handleClose = (modal) => {
    var x = [];
    x[modal] = false;
    this.setState(x);
  }

  loadData = () => {
    let actionsStats = {
      points: 0,
      confirmed: 0,
      pending: 0,
      assigned: 0
    }


    // Load data for Table
    // if there are no actions make a default one

    if (this.props.actionsData.dataRows.length === 0) {
      setFirstAction(this.props.authUser)
    }

    let actionsData = this.props.actionsData.dataRows.map((prop, key) => {
      let colObj = { ...prop }

      const actionID = colObj.actionId
      const title = colObj.title

      // Load Data for Summary Cards and add buttons
      switch (colObj.status) {
        case "assigned":
          actionsStats["assigned"] += 1
          return {
            ...colObj,
            // status: (<span style={{ color: "red" }}>assigned</span>),
            id: key,
            actions: (
              <Button
                color="primary"
                fullWidth
                onClick={
                  () => this.handleClickOpen("updateActionModal",
                    actionID,
                    title,
                  )}
              >DISPATCH</Button>)
          };
        case "pending":
          actionsStats["pending"] += 1
          return {
            ...colObj,
            // status: (<span style={{ color: "yellow" }}>pending</span>),
            id: key,
            actions: (
              <Button
                color="info"
                fullWidth
                onClick={
                  () => this.handleClickOpen("updateActionModal",
                    actionID,
                    title,
                  )}
              >UPDATE</Button>)
          };
        case "confirmed":
          actionsStats["confirmed"] += 1
          actionsStats["points"] += parseInt(colObj.points)
          return {
            ...colObj,
            id: key,
            // status: (<span style={{ color: "#7ddb46" }}>confirmed</span>),
            actions: (
              <Button
                color="info"
                fullWidth
                onClick={
                  () => this.handleClickOpen("updateActionModal",
                    actionID,
                    title,
                  )}
              >UPDATE</Button>)
          };
      }
    })

    // LEADERBOARD
    let userRow = this.props.users.dataRows[this.props.users.userIndex]

    // Update points if wrong
    if (actionsStats.points !== userRow[1]) {
      setUserScore(actionsStats.points, this.props.authUser.uid)
    }

    // Make the users row blue
    userRow = userRow.map(datum => {
      return <p style={{ color: "#24aee4", marginBottom: '0' }}>{datum}</p>
    })
    this.props.users.dataRows[this.props.users.userIndex] = userRow

    this.setState({
      actionsStats,
      actionsData,
      users: this.props.users,
      UID: this.props.authUser.uid,
      dataLoaded: true
    })
  }

  handleChange = (docID) => {
    console.log(docID)
  }

  loadOrdersData = () => {
    let data = db.collection("haney-orders")
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          ordersData: data,
          ordersDataLoaded: true,
        })
      })
  }

  loadShippersData = () => {
    let data = db.collection("haney-shippers").orderBy("name")
      .get().then((snapshot) => {
        //console.log(snapshot)
        const data = []
        // Parse data into array like in firebase.js
        snapshot.forEach((doc) => {
          var docData = doc.data()
          var docObj = {
            id: doc.id,
            ...docData
          }
          data.push(docObj);
        })
        return (data)
      }, (error) => {
        console.log('error fetching data: ', error)
      }).then(data => {
        data
        this.setState({
          shippersData: data,
          shippersDataLoaded: true,
        })
      })
  }

  selectFlight = (flight) => {
    this.setState({ flight: flight })
  }

  //   requestSignature = () => {
  //     const axios = require("axios");

  //     axios({
  //       "method": "POST",
  //       "url": `https://arcane-lowlands-31408.herokuapp.com/https://api.eversign.com/api/document?access_key=751efbc709ec4ace1d6ff70a062b7243&business_id=246480`,
  //       "data": {
  //         "sandbox": 0,
  //         "is_draft": 0,
  //         "embedded": 1,
  //         "title": `Haney Freightways Document House Waybill #${this.props.orderID}`,
  //         "message": "This is my general document message.",
  //         "use_signer_order": 0,
  //         "reminders": 1,
  //         "require_all_signers": 1,
  //         "custom_requester_name": "",
  //         "custom_requester_email": "",
  //         "redirect": "",
  //         "redirect_decline": "",
  //         "client": "",
  //         "expires": 1750513480,
  //         "embedded_signing_enabled": 1,
  //         "flexible_signing": 0,
  //         "use_hidden_tags": 0,
  //         "files": [{
  //           "name": "House Waybill",
  //           "file_url": "https://firebasestorage.googleapis.com/v0/b/ltr-app.appspot.com/o/agreements%2F2020-02-27%20PONDATA%20MASTER%20SERVICES%20AGREEMENT%20(2020-02)FINAL.docx.pdf?alt=media&token=0f3244d1-d6c8-4047-bbfb-cf00b63bd928",
  //           "file_id": "",
  //           "file_base64": ""
  //         }],
  //         "signers": [{
  //           "id": 1,
  //           "name": "Marc",
  //           "email": "justin@maren-go.com",
  //           "order": 1,
  //           // "pin": "3874",
  //           "message": "This is my custom message to Shipper.",
  //           "deliver_email": 0,
  //           "language": "en"
  //         }, {
  //           "id": 2,
  //           // "name": (this.state.driversDropOffData[0].firstName + this.state.driversDropOffData[0].firstName),
  //           "name": "Driver Signer",
  //           "email": "justin@pondata.com",
  //           "order": 2,
  //           // "pin": "3874",
  //           "message": "This is my custom message to Driver.",
  //           "deliver_email": 0,
  //           "language": "en"
  //         }],
  //         "recipients": [{
  //           "name": "Justin",
  //           "email": "development@kordspace.com",
  //           "language": "en"
  //         }],
  //         "meta": {
  //           "some_key": "some_value",
  //           "another_key": "another_value"
  //         },
  //         "fields": [
  //           [{
  //             "type": "signature",
  //             "x": "520",
  //             "y": "930",
  //             "width": "120",
  //             "height": "35",
  //             "page": "1",
  //             "signer": "1",
  //             "name": "",
  //             "identifier": "unique_field_identifier_1",
  //             "required": 1,
  //             "readonly": 0,
  //             "validation_type": "",
  //             "text_size": "",
  //             "text_color": "",
  //             "text_font": "",
  //             "text_style": "",
  //             "value": "",
  //             "options": [],
  //             "group": ""
  //           },{
  //             "type": "signature",
  //             "x": "50",
  //             "y": "995",
  //             "width": "120",
  //             "height": "35",
  //             "page": "1",
  //             "signer": "2",
  //             "name": "",
  //             "identifier": "unique_field_identifier_2",
  //             "required": 1,
  //             "readonly": 0,
  //             "validation_type": "",
  //             "text_size": "",
  //             "text_color": "",
  //             "text_font": "",
  //             "text_style": "",
  //             "value": "",
  //             "options": [],
  //             "group": ""
  //           }]
  //         ]
  //       }
  //       // "params": {
  //       //   "withFlightInfoOnly": "false"
  //       // }
  //     })
  //     .then((response) => {
  //       console.log(response);
  //       this.setState({
  //         signingURL: response.data.signers[0].embedded_signing_url,
  //         signingURL1: response.data.signers[0].embedded_signing_url,
  //         signingURL2: response.data.signers[1].embedded_signing_url,
  //         signatureURLLoaded: true,
  //       })
  //     }, (error) => {
  //       console.log(error);
  //     }).then(async () => {
  //       console.log(this.state.orderData.origin.email)
  //       //const email = this.props.user.email

  //       let subject = `LTR Contract`
  //       let html = `<p>Thanks again for choosing Haney Freightways!</p>`
  //       html += `<a href="${this.state.signingURL1}">Review & Sign Here</a>`
  //       html += `<a href="${this.state.signingURL2}">Review & Sign Here</a>`
  //       // html += `<p>You have been invited to Legalese click here: localhost:3000/pages/signup/${this.props.authUser.uid}/case/${this.props.caseID}</p>`
  //       const emails = [this.state.orderData.origin.email]
  //       const attatchment = true;
  //       const emailReturn = await sendEmail({
  //         emails,
  //         subject,
  //         html,
  //         attatchment
  //       })

  //     }).then(() => {
  //       window.location.reload()
  //     })


  // }

  loadKeepTruckin = () => {
    this.setState({
      ktLoaded: true
    })
    console.log("loadingKt")
    let vehicles = []
    let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=1`
    axios.get(
      url,
      {
        "headers": {
          "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
        }
      }
    ).then((response) => {
      // add truck location to accumulator
      console.log(response.data.vehicles)
      //   const location = response.data.vehicles[0].vehicle.current_location
      //   let truck = {
      //     truckLocation: {
      //       lat: location.lat,
      //       lng: location.lon
      //     }
      //   }
      Array.prototype.push.apply(vehicles, response.data.vehicles);

      let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=2`
      axios.get(
        url,
        {
          "headers": {
            "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
          }
        }
      ).then((response) => {
        // add truck location to accumulator
        // console.log(response.data.vehicles)
        //   const location = response.data.vehicles[0].vehicle.current_location
        //   let truck = {
        //     truckLocation: {
        //       lat: location.lat,
        //       lng: location.lon
        //     }
        //   }
        Array.prototype.push.apply(vehicles, response.data.vehicles);
        let url = `https://safe-brook-14632.herokuapp.com/https://api.keeptruckin.com/v1/vehicle_locations?vehicle_ids=&per_page=100&page_no=3`
        axios.get(
          url,
          {
            "headers": {
              "x-api-key": "f91ab8bc-ba2b-4a43-8fd9-721469b51e22"
            }
          }
        ).then((response) => {
          // add truck location to accumulator
          // console.log(response.data.vehicles)
          //   const location = response.data.vehicles[0].vehicle.current_location
          //   let truck = {
          //     truckLocation: {
          //       lat: location.lat,
          //       lng: location.lon
          //     }
          //   }
          Array.prototype.push.apply(vehicles, response.data.vehicles);
          // console.log(vehicles)
          this.setState({
            vehicles: vehicles,
            vehiclesReady: true
          })


        })
          .catch((error) => {
            console.log(error)
          })

      })
        .catch((error) => {
          console.log(error)
        })

    })
      .catch((error) => {
        console.log(error)
      })

  }


  filterVehicles = () => {
    // console.log("filtering vehicles")
    var filteredVehicles = this.state.vehicles.filter(function (el) {
      // console.log(el.vehicle)
      return el.vehicle.current_location != null
    }
    )
    // console.log(filteredVehicles)

    this.setState({
      filteredVehicles: filteredVehicles,
      filterVehiclesLoaded: true
    })
  }

  noGroupsOrders = (orders) => {

    let noGroupsOrders = []
    orders.map((order) => {
      if (order.groups) {
        if (order.groups.length == 0) {
          if (!order.test) { noGroupsOrders.push(order) }
        }
      } else {
        if (!order.test) { noGroupsOrders.push(order) }
      }
    })

    this.setState({
      noGroupsOrders: noGroupsOrders,
      noGroupsOrdersLoaded: true
    })
  }

  noGroupsShippers = (shippers) => {

    let noGroupsShippers = []
    shippers.map((shipper) => {
      if (shipper.groupArray) {
        if (shipper.groupArray.length == 0) {
          noGroupsShippers.push(shipper)
        }
      } else {
        noGroupsShippers.push(shipper)
      }
    })

    this.setState({
      noGroupsShippers: noGroupsShippers,
      noGroupsShippersLoaded: true,
    })
  }

  // noGroupsShippers = async (shippers) => {

  //   let shipperSnaps = await Promise.all(shippers.map((shipper) => {
  //     let shipperGroupData = db.collection("haney-shippers").doc(shipper.id).collection("haney-groups")
  //         .get().then((snapshot) => {
  //           //console.log(snapshot)
  //           const data = []
  //           // Parse data into array like in firebase.js
  //           snapshot.forEach((doc) => {
  //             var docData = doc.data()
  //             var docObj = {
  //               id: doc.id,
  //               ...docData
  //             }
  //             data.push(docObj);
  //           })
  //           return (data)
  //         }, (error) => {
  //           console.log('error fetching data: ', error)
  //         }).then(data => {
  //           console.log(data)
  //           if (data[0]) {
  //             db.collection("haney-shippers")
  //             .doc(shipper.id)
  //             .set({ groupArray: [data[0].id] }, { merge: true })
  //           }

  //           // console.log(data.length)

  //           // if (data.length == 0) {
  //           //   // console.log(shipper)
  //           //   this.setState(prevState => ({
  //           //     noGroupsShippers: {                   // object that we want to update
  //           //         ...prevState.noGroupsShippers,    // keep all other key-value pairs
  //           //         [shipper.id]: shipper       // update the value of specific key
  //           //     }
  //           // }))
  //           // }
  //         })
  //     // if (shipper.groups) {
  //     //   if (shipper.groups.length == 0) {
  //     //     noGroupsShippers.push(shipper)
  //     //   }
  //     // } else {
  //     //   noGroupsShippers.push(shipper)
  //     // }
  //   }))

  // } 

  render() {
    const { AuthBool, classes } = this.props;

    // Format and upload data to firestore
    // updateFirestoreWithTableData('TEST-actions-list',(tableToFirestoreObjects(this.props.actionsData)))
    // updateFirestoreWithTableData('TEST-users',(tableToFirestoreObjects(this.props.users)))

    // // add uid to firestore documents
    // if(this.state.dataLoaded === true){
    //   this.props.actionsData.dataRows.map(row => addFieldToDocument(row[0], {volUID: "TestID"}))
    // }  



    function filterCaseInsensitive(filter, row) {
      const id = filter.pivotId || filter.id;
      return row[id] !== undefined
        ? (String(row[id]).toLowerCase()).includes(filter.value.toLowerCase())
        : true;
    }

    if (AuthBool) {
      if (this.props.actionsData.dataLoaded
        && this.props.users.dataLoaded
        && !this.state.dataLoaded) {
        this.loadData()
      }
    }

    if (AuthBool) {
      if (this.props.users.dataLoaded
        && !this.state.ordersDataLoaded) {
        this.loadOrdersData()
      }
    }

    if (AuthBool) {
      if (this.props.users.dataLoaded
        && !this.state.shippersDataLoaded) {
        this.loadShippersData()
      }
    }

    if (this.state.ordersDataLoaded) {
      var pendingOrders = this.state.ordersData.filter(function (order) {
        return order.status === "pending";
      });
      var dispatchedOrders = this.state.ordersData.filter(function (order) {
        return order.status === "dispatched";
      });
      var confirmedOrders = this.state.ordersData.filter(function (order) {
        return order.status === "completed";
      });
      console.log(this.state.ordersData)
      console.log(pendingOrders.length)
      console.log(dispatchedOrders.length)
      console.log(confirmedOrders.length)
    }

    if (!this.state.ktLoaded) {
      this.loadKeepTruckin()
    }

    if (this.state.vehiclesReady && !this.state.filterVehiclesLoaded) {
      this.filterVehicles()
    }

    if (this.state.ordersData && !this.state.noGroupsOrdersLoaded) {
      this.noGroupsOrders(this.state.ordersData)
    }

    if (this.state.shippersData && !this.state.noGroupsShippersLoaded) {
      this.noGroupsShippers(this.state.shippersData)
    }

    console.log(this.state)

    return (
      <div>
        {/* <div style={{margin: "-15px"}}>
          {(this.state.coordinates.origin || this.state.coordinates.destination) && <ShipFullScreenMap originCoords={this.state.coordinates.origin} destinationCoords={this.state.coordinates.destination} driverCoords={this.state.coordinates.driver} />}
        </div> */}
        {this.state.filteredVehicles &&
          <AllTrucks vehicles={this.state.filteredVehicles} />
        }
        {
          this.state.dataLoaded ? (
            <GridContainer>
              {/* <GridItem xs={12} md={3}>
              <Chat
                  orderID={this.state.orderID}
                  channel='dispatch'
                />
              </GridItem> */}
              <GridItem xs={12} >
                <TaskViewer />
              </GridItem>


              <GridItem xs={12}>
                <GridContainer>
                  <GridItem xs={12} md={6} lg={3}>
                    <Card>
                      {/* <h2 className={classes.cardTitle}>{pendingOrders && pendingOrders.length}</h2> */}
                      <p className={classes.cardSubtitle} style={{ margin: "auto" }}>OPEN ORDERS</p>
                    </Card>
                  </GridItem>
                  <GridItem xs={12} md={6} lg={3}>
                    <Card>
                      {/* <h2 className={classes.cardTitle}>{dispatchedOrders && dispatchedOrders.length}</h2> */}
                      <p className={classes.cardSubtitle} style={{ margin: "auto" }}  >DOCKED ORDERS</p>
                    </Card>
                  </GridItem>
                  <GridItem xs={12} md={6} lg={3}>
                    <Card>
                      {/* <h2 className={classes.cardTitle}>{confirmedOrders && confirmedOrders.length}</h2> */}
                      <p className={classes.cardSubtitle} style={{ margin: "auto" }}>OTR TRIPS</p>
                    </Card>
                  </GridItem>
                  <GridItem xs={12} md={6} lg={3}>
                    <Card>
                      {/* <h2 className={classes.cardTitle}>{confirmedOrders && confirmedOrders.length}</h2> */}
                      <p className={classes.cardSubtitle} style={{ margin: "auto" }}>LOCAL TRIPS</p>
                    </Card>
                  </GridItem>
                </GridContainer>
                <hr />
                <GridContainer xs={12} justify="center" >
                  <GridItem xs={12} md={6} lg={3} justify="center">
                    <b><h3 style={{ textAlign: "center" }}>Notifications</h3></b>
                    <NotificationsDash />
                  </GridItem>
                </GridContainer>
                <hr />
                <GridContainer xs={12} justify="center">
                  <GridItem xs={12} md={6} lg={3}>
                    <p className={classes.cardSubtitle} style={{ margin: "auto" }}>Unassociated Orders
                      <Switch
                        checked={this.state.checkedOrders}
                        onChange={() => this.handleSwitchOrders(!this.state.checkedOrders)}
                        label={<span style={{ marginRight: "10px" }}>{this.state.checkedShippers ? "Show" : "Hide"}</span>}
                        labelPlacement="start"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar,
                        }}
                      />
                    </p>
                    <List style={{ maxHeight: "500px", overflow: "auto" }}>
                      <Collapse in={this.state.checkedOrders}>
                        {this.state.noGroupsOrdersLoaded && this.state.noGroupsOrders.map((order, i) => {
                          return (
                            <ListItem key={i} style={{ width: "100%" }} >
                              <Link to={`/order/${order.id}`}>
                                <Card style={{ padding: "10px", minWidth: "100%", margin: "auto", }}>
                                  <p style={{ margin: "auto" }}>{order.id}</p>
                                </Card>
                              </Link>
                            </ListItem>
                          )
                        })}
                      </Collapse>
                    </List>
                  </GridItem>
                  <GridItem xs={12} md={6} lg={3}>
                    <p className={classes.cardSubtitle} style={{ margin: "auto" }}>
                      Unassociated Shippers

                      <Switch
                        checked={this.state.checkedShippers}
                        onChange={() => this.handleSwitchShipper(!this.state.checkedShippers)}
                        label={<span style={{ marginRight: "10px" }}>{this.state.checkedShippers ? "Show" : "Hide"}</span>}
                        labelPlacement="start"
                        classes={{
                          switchBase: classes.switchBase,
                          checked: classes.switchChecked,
                          icon: classes.switchIcon,
                          iconChecked: classes.switchIconChecked,
                          bar: classes.switchBar,
                        }}
                      />
                    </p>


                    {console.log("APPLE", this.state)}
                    {/* {console.log(this.state.noGroupsShippers.length)} */}
                    <List style={{ maxHeight: "500px", overflow: "auto" }}>
                      <Collapse in={this.state.checkedShippers}>
                        {
                          this.state.noGroupsShippersLoaded && this.state.noGroupsShippers.map((shipper, i) => {
                            // console.log(shipper) 
                            return (
                              <ListItem key={i} style={{ width: "100%" }} >
                                <Link to={`/shipper/${shipper.id}`}>
                                  <Card style={{ padding: "10px", minWidth: "100%", margin: "auto", }}>
                                    <p style={{ margin: "auto" }}>{shipper.name}</p>
                                  </Card>
                                </Link>
                              </ListItem>
                            )
                          }

                          )

                        }
                      </Collapse>
                    </List>

                  </GridItem>
                </GridContainer>
                <br />
                {/* <GridContainer>
                  <GridItem xs={12}>
                    Notifications:
                    <NotificationsParent />
                  </GridItem>
                </GridContainer> */}
              </GridItem >


              <GridItem xs={12} md={5}>
              {/* <FlightSearchForm onSelectFlight={this.selectFlight} />*/}
               <MarketAreaConverter />
              {/* <Button
                              style={{ float: "right", marginTop: "20px" }}
                              color="primary"
                              onClick={() => this.requestSignature()}
                            >RE</Button> */}
              </GridItem>

              {/*} <GridItem xs={12} lg={9}>
                <h1 className={classes.title}>ORDERS LIST</h1>
                <div>
                  <ReactTable
                    data={this.state.actionsData}
                    filterable
                    defaultFilterMethod={filterCaseInsensitive}
                    columns={this.props.actionsData.columns}
                    defaultPageSize={10}
                    defaultSorted={[
                      {
                        id: "status",
                        desc: false
                      }
                    ]}
                    //showPaginationTop
                    showPaginationBottom
                    style={{
                      color: "#fff"
                    }}
                    className="-striped -highlight"
                    SubComponent={row => {
                      const rowData = this.state.actionsData[row.index]
                      return (
                        <GridContainer>
                          <GridItem xs={7} sm={12}>
                            <GridContainer justify="center">
                              <GridItem xs={11}>
                                <h3 className={classes.cardTitle}>{rowData.title.toUpperCase()}</h3>
                                <p className={classes.cardSubTitle}>{rowData.description}</p>
                                {!!rowData.comment ? (
                                  <div>
                                    <h4 className={classes.cardTitle}>COMMENT:</h4>
                                    <p className={classes.cardSubTitle}>{rowData.comment}</p>
                                  </div>
                                ) : null}
                              </GridItem>
                              <GridItem xs={5} sm={2}>
                                <h4 className={classes.cardTitle}>DUE DATE:</h4>
                                <p className={classes.cardSubTitle}>{rowData.dueDate}</p>
                              </GridItem>
                              <GridItem xs={6} sm={1}>
                                <h4 className={classes.cardTitle}>DAYS:</h4>
                                <p className={classes.cardSubTitle}>{rowData.days}</p>
                              </GridItem>
                              <GridItem xs={5} sm={2}>
                                <h4 className={classes.cardTitle}>STATUS:</h4>
                                <p className={classes.cardSubTitle}>{rowData.status}</p>
                              </GridItem>
                              <GridItem xs={6} sm={2}>
                                <h4 className={classes.cardTitle}>POINTS:</h4>
                                <p className={classes.cardSubTitle}>{rowData.points}</p>
                              </GridItem>
                              <GridItem xs={11} sm={3}>
                                {rowData.actions}
                              </GridItem>
                            </GridContainer>
                          </GridItem>
                        </GridContainer>
                      );
                    }}
                  />
                  {/* UPDATE ACTION MODAL 
                  <Dialog
                    classes={{
                      root: classes.modalRoot,
                      paper: classes.modal + " " + classes.modalLarge
                    }}
                    open={this.state.updateActionModal}
                    TransitionComponent={Transition}
                    keepMounted
                    onClose={() => this.handleClose("updateActionModal")}
                    aria-labelledby="shipment-modal-slide-title"
                    aria-describedby="shipment-modal-slide-description"
                  >
                    <DialogTitle
                      id="shipment-modal-slide-title"
                      disableTypography
                      className={classes.modalHeader}
                    >
                      <Button
                        simple
                        className={classes.modalCloseButton}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.handleClose("updateActionModal")}
                      >
                        {" "}
                        <Close className={classes.modalClose} />
                      </Button>
                      <h2 className={classes.modalTitle}>DISPATCH ORDER: {this.state.editActionTitle}</h2>
                    </DialogTitle>
                    <DialogContent
                      id="shipment-modal-slide-description"
                      className={classes.modalBody}
                    >
                      <ActionSubmitForm
                        UID={this.state.UID}
                        actionID={this.state.editActionID}
                        title={this.state.editActionTitle}
                        modalClose={!this.state.updateActionModal}
                      />
                      <Button
                        className={classes.ltrButtonWhite}
                        style={{
                          marginLeft: "10px",
                          marginTop: "10px"
                        }}
                        key="close"
                        aria-label="Close"
                        onClick={() => this.handleClose("updateActionModal")}
                      >
                        CLOSE
              </Button>
                    </DialogContent>
                  </Dialog>
                </div>
                      </GridItem>

              <GridItem xs={12} lg={3}>
                <GridItem xs={12}>
                  <h2 className={classes.title}>LEADERBOARD</h2>
                  <Table
                    tableHead={this.state.users.tableHead}
                    tableData={this.state.users.dataRows}
                  />
                </GridItem>
              </GridItem>*/}

              <GridContainer justify="center">
                <br />
                <GridItem xs={11} style={{ maxHeight: "500px", overflow: "auto", justify: "center" }}>
                  <FavOrderParent />
                </GridItem>
                <br />
              </GridContainer>


            </GridContainer >

          ) : (
            <p className={classes.cardSubtitle} style={{ margin: "auto" }}>Loading...</p>
          )
        }
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    AuthBool: !!state.auth.user,
    actionsData: state.actions.actions,
    users: state.actions.users,
    authUser: state.auth.user,
    user: state.profile.user
  }
}

// const mapDispatchToProps = (dispatch) => {
//   return {
//     setUserScore: (score) => dispatch(setUserScore(score))
//   }
// }

export default compose(
  connect(mapStateToProps),
  withStyles(Style)
)(Orders);



// WEBPACK FOOTER //
// ./src/views/Actions/Actions.jsx